module.exports = __webpack_public_path__ + "static/media/wedding01.9304e0f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/wedding01.jpg
// module id = 421
// module chunks = 0